import React from 'react';

import Icon, { IconVariant } from 'components/Icon/Icon';

interface DeviceStepsProps {
  icon: JSX.Element;
  title: string;
  description: string;
}

const DeviceSteps: React.FC<DeviceStepsProps> = ({
  icon,
  title,
  description,
}) => (
  <div className="flex w-64 flex-col self-start px-4">
    <Icon icon={icon} variant={IconVariant.XLARGE} />
    <div className="mt-4 w-52 space-y-1 self-center">
      <div className="prose-title-h5">{title}</div>
      <div className="prose-body-sm-reg text-kira-slate-700">{description}</div>
    </div>
  </div>
);
export default DeviceSteps;
